export class ResultConfigViewModel {
  id: string = "";
  materialID: string = "";
  productDescShort: string = "";
  showInResults: boolean = true;
  showInResultsUpdateStatus: string = "";

  constructor() {
  }
}
